import React, { useMemo, useEffect } from 'react';
import Verticalline from '../../../common/Verticalline'
import moment from 'moment/moment';
import { closeModalAction, openCustomModal } from '../../../actions/modal';
import ViewAllRemark from '../../Ticket/Modal/ViewAllRemark';
import { useDispatch, useSelector } from 'react-redux';
import IconToolTip from '../../../common/IconToolTip';
import ButtonScogoOrange from '../../../common/Buttons/ButtonScogoOrange';
import { TicketMilestoneEvents } from '../TicketController';
import { getServiceRequestHistory } from '../../../actions/service_request';
import { SkeltonCardTwo } from '../../../common/SkeltonCardTwo';
import OverflowTip from '../../../common/OverflowTip';
import { ConstructionOutlined } from '@mui/icons-material';

export const TicketMilestoneEventLabels = {
    // Ticket Event Labels
    [TicketMilestoneEvents.CREATED]: {
        label: 'Ticket Created',
        color: 'scogosuccess',
        icon: 'done',
        subLabel: ({ created_at, user }) => `Ticket created by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.AGENTS_ADDED]: {
        label: 'Agents Added',
        color: 'scogogray',
        icon: 'person_add',
        subLabel: ({ created_at, user }) => `Agents added by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.AGENTS_REMOVED]: {
        label: 'Agents Removed',
        color: 'scogogray',
        icon: 'person_remove',
        subLabel: ({ created_at, user }) => `Agents removed by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.TEAMS_ADDED]: {
        label: 'Teams Added',
        color: 'scogogray',
        icon: 'group_add',
        subLabel: ({ created_at, user }) => `Teams added by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.TEAMS_REMOVED]: {
        label: 'Teams Removed',
        color: 'scogogray',
        icon: 'group_remove',
        subLabel: ({ created_at, user }) => `Teams removed by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.UPDATED]: {
        label: 'Ticket Updated',
        color: 'scogogray',
        icon: 'update',
        subLabel: ({ created_at, user }) => `Ticket updated by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.STATUS_CHANGED]: {
        label: 'Status Changed',
        color: 'scogoprimary',
        icon: 'swap_horiz',
        subLabel: ({ created_at, user }) => `Status changed by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.PRIORITY_CHANGED]: {
        label: 'Priority Changed',
        color: 'scogoorange',
        icon: 'priority_high',
        subLabel: ({ created_at, user }) => `Priority changed by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.ARCHIVED]: {
        label: 'Ticket Archived',
        color: 'scogogray',
        icon: 'archive',
        subLabel: ({ created_at, user }) => `Ticket archived by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.UNARCHIVED]: {
        label: 'Ticket Unarchived',
        color: 'scogogray',
        icon: 'unarchive',
        subLabel: ({ created_at, user }) => `Ticket unarchived by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.DELETED]: {
        label: 'Ticket Deleted',
        color: 'scogoclosed',
        icon: 'delete',
        subLabel: ({ created_at, user }) => `Ticket deleted by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.HOLD]: {
        label: 'Ticket On Hold',
        color: 'scogoorange',
        icon: 'pause_circle',
        subLabel: ({ created_at, user }) => `Ticket put on hold by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.RESUME]: {
        label: 'Ticket Resumed',
        color: 'scogosuccess',
        icon: 'play_circle',
        subLabel: ({ created_at, user }) => `Ticket resumed by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.BULK_CHANGE_STATE]: {
        label: 'Bulk State Changed',
        color: 'scogoprimary',
        icon: 'sync_alt',
        subLabel: ({ created_at, user }) => `Bulk state changed by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.HARD_CLOSE]: {
        label: 'Ticket Hard Closed',
        color: 'scogoclosed',
        icon: 'cancel',
        subLabel: ({ created_at, user }) => `Ticket hard closed by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.CLOSED]: {
        label: 'Ticket Closed',
        color: 'scogoclosed',
        icon: 'check_circle',
        subLabel: ({ created_at, user }) => `Ticket closed by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.EXECUTION_DATE_UPDATED]: {
        label: 'Execution Date Updated',
        color: 'scogoprimary',
        icon: 'event',
        subLabel: ({ created_at, user }) => `Execution date updated by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.HELPDESK_ASSIGNED]: {
        label: 'Helpdesk Assigned',
        color: 'scogoprimary',
        icon: 'support_agent',
        subLabel: ({ created_at, user }) => `Helpdesk assigned by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.ADD_TO_CLICKHOUSE]: {
        label: 'Added To Clickhouse',
        color: 'scogogray',
        icon: 'storage',
        subLabel: ({ created_at, user }) => `Added to Clickhouse by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.ADD_OFFLINE_PAYMENT]: {
        label: 'Offline Payment Added',
        color: 'scogosuccess',
        icon: 'payments',
        subLabel: ({ created_at, user }) => `Offline payment added by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.REMARK_ADDED]: {
        label: 'Manual Remark Added',
        color: 'scogogray',
        icon: 'comment',
        subLabel: ({ created_at, user }) => `Manual remark added by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },

    // Milestone Event Labels
    [TicketMilestoneEvents.MILESTONE_CREATED]: {
        label: 'Milestone Created',
        color: 'scogosuccess',
        icon: 'add_circle',
        subLabel: ({ created_at, user }) => `Milestone created by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.MILESTONE_UPDATED]: {
        label: 'Milestone Updated',
        color: 'scogoprimary',
        icon: 'update',
        subLabel: ({ created_at, user }) => `Milestone updated by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.MILESTONE_DELETED]: {
        label: 'Milestone Deleted',
        color: 'scogoclosed',
        icon: 'delete',
        subLabel: ({ created_at, user }) => `Milestone deleted by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.MILESTONE_BROADCASTED]: {
        label: 'Milestone Broadcast',
        color: 'scogoprimary',
        icon: 'campaign',
        subLabel: ({ created_at, user }) => `Milestone broadcast by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.MILESTONE_ACCEPTED]: {
        label: 'Milestone Accepted',
        color: 'scogosuccess',
        icon: 'check_circle',
        subLabel: ({ created_at, user }) => `Milestone accepted by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.MILESTONE_SITE_COMPLETED]: {
        label: 'Site Completed',
        color: 'scogosuccess',
        icon: 'done_all',
        subLabel: ({ created_at, user }) => `Site completed by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.MILESTONE_SIGN_OFF_REQUESTED]: {
        label: 'Sign Off Requested',
        color: 'scogoorange',
        icon: 'assignment',
        subLabel: ({ created_at, user }) => `Sign off requested by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.MILESTONE_SIGN_OFF_ACCEPTED]: {
        label: 'Sign Off Accepted',
        color: 'scogosuccess',
        icon: 'assignment_turned_in',
        subLabel: ({ created_at, user }) => `Sign off accepted by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.MILESTONE_SIGN_OFF_REJECTED]: {
        label: 'Sign Off Rejected',
        color: 'scogoclosed',
        icon: 'assignment_late',
        subLabel: ({ created_at, user }) => `Sign off rejected by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.MILESTONE_ENGINEER_AT_SITE]: {
        label: 'Engineer At Site',
        color: 'scogoprimary',
        icon: 'engineering',
        subLabel: ({ created_at, user }) => `Engineer arrived at site (${user?.display_name}) at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.MILESTONE_ENGINEER_LEFT_SITE]: {
        label: 'Engineer Left Site',
        color: 'scogogray',
        icon: 'directions_walk',
        subLabel: ({ created_at, user }) => `Engineer left site (${user?.display_name}) at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.MILESTONE_TRACKING_REQUESTED]: {
        label: 'Tracking Requested',
        color: 'scogoprimary',
        icon: 'location_on',
        subLabel: ({ created_at, user }) => `Tracking requested by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.MILESTONE_ENGINEER_ON_THE_WAY]: {
        label: 'Engineer On The Way',
        color: 'scogoorange',
        icon: 'directions_car',
        subLabel: ({ created_at, user }) => `Engineer on the way (${user?.display_name}) at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.MILESTONE_INSURANCE_REQUESTED]: {
        label: 'Insurance Requested',
        color: 'scogoprimary',
        icon: 'policy',
        subLabel: ({ created_at, user }) => `Insurance requested by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.MILESTONE_FIELD_ASSIGNED]: {
        label: 'Field Assigned',
        color: 'scogoprimary',
        icon: 'assignment_ind',
        subLabel: ({ created_at, user }) => `Field assigned by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.MILESTONE_TRACKING_DISABLED]: {
        label: 'Tracking Disabled',
        color: 'scogogray',
        icon: 'location_off',
        subLabel: ({ created_at, user }) => `Tracking disabled by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.MILESTONE_MAP_FAULTY_ASSET]: {
        label: 'Map Faulty Asset',
        color: 'scogogray',
        icon: 'location_off',
        subLabel: ({ created_at, user }) => `Map faulty asset by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    },
    [TicketMilestoneEvents.MILESTONE_ADD_BOQ]: {
        label: 'Add BOQ',
        color: 'scogogray',
        icon: 'inventory_2',
        subLabel: ({ created_at, payload }) => {
            const assetInfo = payload?.asset_type ? `${payload.asset_type} (${payload.serial_number})` : '';
            return `Add BOQ for ${assetInfo} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`;
        }
    },
    [TicketMilestoneEvents.MILESTONE_UPDATE_RMA]: {
        label: 'Update RMA',
        color: 'scogogray',
        icon: 'inventory_2',
        subLabel: ({ created_at, user, payload }) => {
            const vendorInfo = payload?.vendor ? `${payload.vendor} (${payload.vendor_id})` : '';
            const consumptionType = payload?.consumption_type ? `${payload.consumption_type}` : '';
            const status = payload?.status ? `${payload.status}` : '';
            return `Update RMA by ${user?.display_name} with status ${status}, vendor ${vendorInfo}, consumption ${consumptionType} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`;
        }
    },
    [TicketMilestoneEvents.VENDOR_RELEASED]: {
        label: 'Vendor Released',
        color: 'scogogray',
        icon: 'inventory_2',
        subLabel: ({ created_at, user, payload }) => `Vendor released by ${user?.display_name} at ${moment(created_at).format('DD-MM-YYYY HH:mm')}`
    }
};

const iconNames = {
    COMPLETE: { status: "done", color: "scogosuccess" },
    ALERT: { status: 'warning', color: 'scogoclosed' },
    EMPTY: { status: '', color: 'scogogray' },
    WAITING: { status: 'hourglass_bottom', color: 'scogoorange' }
}


const Progress = ({ serviceRequest }) => {
    const dispatch = useDispatch();
    const serviceRequestList = useSelector((state) => state.serviceRequest.serviceRequestList);
    const serviceRequestHistory = useSelector((state) => state.serviceRequest.serviceRequestHistory);
    const isServiceRequestHistoryLoading = useSelector((state) => state.loading.isServiceRequestHistoryLoading);

    useEffect(() => {
        if (serviceRequest?.id && !serviceRequestHistory[serviceRequest?.id]) {
            dispatch(getServiceRequestHistory({ ticketId: serviceRequest?.id }));
        }
    }, [dispatch, serviceRequest?.id]);

    const history = useMemo(() => {
        if (serviceRequestHistory && serviceRequest?.id && serviceRequestHistory[serviceRequest?.id]) {
            return serviceRequestHistory[serviceRequest?.id].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
        }
        return [];
    }, [serviceRequest?.id, serviceRequestHistory]);

    const viewHistory = () => {
        let modalComponent = <ViewAllRemark closeModal={() => dispatch(closeModalAction())} ticketId={serviceRequest?.id} source='ticket_table' remarkList={serviceRequest?.remarks} callHistory={true} />
        let modalWidth = '60em',
            modalHeight = '70vh';
        let head = 'History';
        dispatch(openCustomModal({ modalComponent, heading: head, modalWidth, modalHeight }));
    };

    const getIconColor = (item) => {
        return `${iconNames[item?.status] ? iconNames[item?.status]?.color : 'scogogray'}`
    };

    if (isServiceRequestHistoryLoading) {
        return <div className='w-full px-4'>
            <SkeltonCardTwo arr={[1, 2, 3]} height={13} />
        </div>
    }

    return (
        <div className="bg-white rounded-lg shadow-sm">
            {history.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-8">
                    <span className="material-icons text-gray-400 text-4xl mb-2">history</span>
                    <p className="text-gray-500">No history available for this ticket</p>
                </div>
            ) : (
                <div className="relative w-full">
                    <ul className="divide-y divide-gray-100 w-full">
                        {Array.isArray(history) && history.map((item, index) => {
                            let eventLabel = TicketMilestoneEventLabels[item.action];
                            if (!eventLabel) {
                                return null;
                            }
                            return (
                                <li key={index} className={`relative py-4 hover:bg-gray-50 transition-colors duration-150 ${index % 2 !== 0 ? 'bg-gray-50' : 'bg-white'}`}>
                                    <div className="flex items-start px-4 w-full">
                                        <div className="flex-shrink-0 mr-4">
                                            <div className={`h-14 w-14 rounded-full flex items-center justify-center bg-${eventLabel?.color}-50 border-2 border-${eventLabel?.color}`}>
                                                <span className={`material-icons text-${eventLabel?.color} text-2xl`}>
                                                    {eventLabel?.icon}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="flex-1 min-w-0">
                                            <p className="text-font13 font-medium text-gray-900 truncate">
                                                {eventLabel?.label}
                                            </p>
                                            <p className="text-font11 text-gray-500 mt-1 truncate max-w-[25rem]">
                                                <OverflowTip someLongText={eventLabel?.subLabel({ created_at: item.created_at, user: item.user, payload: item.payload })} />
                                            </p>
                                        </div>
                                        <div className="flex-shrink-0 ml-2">
                                            <span className="text-md text-gray-500">
                                                {moment(item.created_at).fromNow()}
                                            </span>
                                        </div>
                                    </div>
                                    <Verticalline
                                        marginTop="-3px"
                                        isLast={index + 1 === history.length}
                                        color={getIconColor(item)}
                                        lineHeight="2.2rem"
                                        marginLeft="2.6rem"
                                    />
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}

            {serviceRequest?.remarks && Array.isArray(serviceRequest?.remarks) && serviceRequest?.remarks.length > 0 && (
                <div className="p-4 border-t border-gray-200 bg-gray-50">
                    <IconToolTip title={'View Complete History'}>
                        <ButtonScogoOrange
                            buttonClass="w-full py-2 flex items-center justify-center gap-2 rounded-md"
                            textOrComponent={
                                <div className="flex items-center">
                                    <span className="material-icons mr-2 text-sm">history</span>
                                    <span>View Complete History</span>
                                </div>
                            }
                            onClick={viewHistory}
                        />
                    </IconToolTip>
                </div>
            )}
        </div>
    );
}

export default Progress;